import { Socket } from 'rete'

const NodeSocket = new Socket('Node ID value')

export default NodeSocket
